import { ILocal705PensionInputs } from 'app/calcs/customers/local705/interfaces'
import { IMonthlyPensionPayments, SimplePensionFormOfPayment, SimplePensionFormOfPaymentKinds } from 'app/calcs/pensions/interfaces'
import { ActionCreator } from 'app/redux/ActionCreator'
import { ActionTypes, ILocal705OpAction, ILocal705OpState } from 'app/redux/Customers/local705/reducer'
import { PensionActionCreator } from 'app/redux/Pensions/actions'
import { ageAt, IRetirementPerson, isSamePersonForSSA, personHasRetired, Profile } from 'app/redux/Profile/model'
import { IPokeandPullRequest, IRequestedValues, IWorkbookValues, WorkbookServiceResponse } from 'app/services/models/Workbook'
import { OperationStatus } from 'app/services/OperationStatus'
import { genericFailure } from 'app/services/WebServiceBase'
import { WorkbookService } from 'app/services/WorkbookService'
import * as utils from 'app/utils'
import { INosyParker, nullNosyParker } from 'app/utils/nosyParker'
import { Local705WorkbookDAO } from 'app/workbookDAOs/local705DAO'
import { getWebServicesConfig } from 'config'
import { config } from 'dotenv';
import * as _ from 'lodash'
import * as moment from 'moment'

class Local705ActionCreator extends PensionActionCreator<ILocal705OpState, ILocal705OpAction> {
  public workbook: Local705WorkbookDAO

  constructor() {
    super(ActionTypes)
    this.workbook = new Local705WorkbookDAO(this)
  }

}

const Local705Actions = new Local705ActionCreator()
const cachedLocal705RunCalculations = _.memoize(Local705Actions.workbook.runCalculations.bind(Local705Actions.workbook), JSON.stringify)

export {
  Local705Actions,
  Local705ActionCreator,

  cachedLocal705RunCalculations
}



// WEBPACK FOOTER //
// ./src/app/redux/Customers/Local705/actions/index.ts